<div class="display-flex flex-column full-height">
  <app-jumbotron class="mb-10">
    <div class="container display-flex flex-align-center page-help gap-1-rem">
      <div class="text-justify flex-grow">
        {{ 'dimensions.dimensions_categories_info' | translate }}
      </div>
      <div class="display-flex flex-align-center gap-1-rem">
        <app-help-button template="dimension-categories"></app-help-button>
        <app-button icon="add"
                    buttonType="mat-flat-button"
                    [disabled]="appS.isNotDatasetAdmin"
                    (onClick)="onCreate()">{{ 'settings.add_dimensions_group' | translate }}</app-button>
      </div>
    </div>
  </app-jumbotron>
  <app-jumbotron class="flex-grow">
    <app-dimensions-category-table></app-dimensions-category-table>
  </app-jumbotron>
</div>
